module.exports = __webpack_public_path__ + "img/4.8da0c13e.jpg";